import styles from './Header.module.css'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { FormBuilderContext } from '../../store/store.FormBuilder'

const Header = observer(() => {
  const storeFormBuilder = useContext(FormBuilderContext)
  return (
    <header className={styles.header}>
      <button onClick={storeFormBuilder.toggleIsSidebarEditorOpen}>
        Editor
      </button>
      <button onClick={storeFormBuilder.toggleIsSidebarPageOpen}>Pages</button>
    </header>
  )
})

export default Header
